import { call, select, put, takeLatest, all } from "redux-saga/effects";
import api from "../../Environment";
import { FETCH_SINGLE_PAGE_START, FETCH_SITE_WORKING_CONTENT_START } from "../actions/ActionConstant";
import { createNotification } from "react-redux-notify";
import {
  getSuccessNotificationMessage,
  getErrorNotificationMessage,
} from "../../components/helper/NotificationMessage";
import {
  fetchSinglePageSuccess,
  fetchSinglePageFailure,
  fetchHowItWorksContentSuccess,
  fetchHowItWorksContentFailure,
} from "../actions/PageAction";
import { showErrorComponent } from "../actions/ComponentAction";

function* fetchSinglePage() {
  try {
    const inputData = yield select((state) => state.page.pageData.inputData);
    const response = yield api.postMethod("static_pages", inputData);
    if (response.data.success) {
      yield put(fetchSinglePageSuccess(response.data.data));
    } else {
      yield put(fetchSinglePageFailure(response.data.error));
      const notificationMessage = getErrorNotificationMessage(
        response.data.error
      );
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    yield put(fetchSinglePageFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(error.message);
    yield put(createNotification(notificationMessage));
  }
}

function* fetchAboutPageData() {
  try {
    const response = yield api.getMethod("reports/get_how_it_works_content");
    if (response.data.success) {
      yield put(fetchHowItWorksContentSuccess(response.data.data));
    } else {
      yield put(fetchHowItWorksContentFailure(response.data.error));
      const notificationMessage = getErrorNotificationMessage(
        response.data.error
      );
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    yield put(fetchHowItWorksContentFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(error.message);
    yield put(createNotification(notificationMessage));
  }
}

export default function* pageSaga() {
  yield all([yield takeLatest(FETCH_SINGLE_PAGE_START, fetchSinglePage)]);
  yield all([yield takeLatest(FETCH_SITE_WORKING_CONTENT_START, fetchAboutPageData)]);
}
